const Header = ({ title, description }: { title: string; description: string }) => {
  return (
    <header className="mb-24 mt-48 container-md text-center">
      <h2 className="flex-1 mt-8 text-2xl text-gray-darker md:flex-none lg:mt-12">{title}</h2>
      <p className="text-lg text-gray-dark">{description}</p>
    </header>
  );
};

export default Header;
